import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../../service-base';

const CLASS_NAME = 'RecurringInvoiceEndingMode';
const ENDPOINT = `/recurring-invoice-ending-modes/`;

@Injectable({
    providedIn: 'root'
})
export class RecurringInvoiceEndingModeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
